const currentYear = new Date().getFullYear();

export const deCustomMessages = {
    oui: 'Ja',
    non: 'Nein',
    action_annuler: 'Annuler',
    action_sauver: 'Sauver',
    //------------------------------------------------------------------------------------------------------------------
    // Menu
    //------------------------------------------------------------------------------------------------------------------
    fichier: 'Datei',
    ouvrir: 'Öffnen',
    sauver: 'Speichern',
    exportPDF: 'Als PDF exportiere',
    //------------------------------------------------------------------------------------------------------------------
    menu: 'Menu',
    lectureMenu: 'Mode lecture',
    editMenu: 'Mode édition',
    reorderingMenu: 'Mode arrangement',
    //------------------------------------------------------------------------------------------------------------------
    libelleMenu: "Libellé",
    //------------------------------------------------------------------------------------------------------------------
    // Confirmation delete
    //------------------------------------------------------------------------------------------------------------------
    confirmation_delete_titre: "Confirmation de suppression",
    confirmation_delete_question: "Êtes-vous sûr de vouloir supprimer « {VAR} » ?",
    confirmation_delete_enfant: "Je vous informe également que ça supprimera tous les enfants, c'est-à-dire {VAR} element.",
    confirmation_delete_enfants: "Je vous informe également que ça supprimera tous les enfants, c'est-à-dire {VAR} elements.",
    //------------------------------------------------------------------------------------------------------------------
    // Icon
    //------------------------------------------------------------------------------------------------------------------
    icon_titre: "Sélection de l'icône",
    icon_msg_pour: "Ceci changera l'icône pour « {VAR} ».",
    //------------------------------------------------------------------------------------------------------------------
    // Settings
    //------------------------------------------------------------------------------------------------------------------
    parametres: 'Einstellungen',
    choixCouleur: 'Eine Farbe auswählen :',
    //------------------------------------------------------------------------------------------------------------------
    greeting: "Hallo, Maria!",
    welcome: "Willkommen zurück",
    search: "Suchen",
    aiAssistant: "KI-Assistent",
    overview: "Übersicht",
    earnings: "Einnahmen",
    spendings: "Ausgaben",
    thanLastMonth: "als im letzten Monat",
    savings: "Ersparnisse",
    education: "Bildung",
    dreamHome: "Traumhaus",
    car: "Auto",
    holidays: "Urlaub",
    healthcare: "Gesundheit",
    budgetUtilization: "Budgetnutzung",
    budgetUsed: "50% des Budgets verwendet",
    totalBudget: "Gesamtbudget",
    usedBudget: "Verwendetes Budget",
    transactions: "Transaktionen",
    pdfExport: "Als PDF exportieren",
    excelExport: "Als Excel exportieren",
    personalTransactions: "Persönliche Transaktionen",
    transactionDetails: "Transaktionsdetails",
    merchant: "Händler",
    orderStatus: "Bestellstatus",
    time: "Zeit",
    customer: "Kunde",
    email: "E-Mail",
    paymentMethod: "Zahlungsmethode",
    transactionHash: "Transaktions-Hash",
    from: "Von",
    to: "Nach",
    investments: "Investitionen",
    totalInvestments: "Gesamtinvestitionen",
    stocks: "Aktien",
    realEstates: "Immobilien",
    bonds: "Anleihen",
    mutualFunds: "Investmentfonds",
    cryptocurrency: "Kryptowährung",
    commodities: "Rohstoffe",
    todayMovers: "Die Top 5 Bewegungen heute",
    stockChart: "Aktienchart",
    value: "Wert",
    volume: "Volumen",
    analytics: "Analytik",
    moneyCashflow: "Geldfluss",
    year: "Jahr",
    month: "Monat",
    personalInformation: "Persönliche Informationen",
    settings: "Einstellungen",
    calendar: "Kalender",
    cardInformation: "Karteninformation",
    weather: "Wetter",
    save: "Speichern",
    restore: "Restore",
    name: "Name",
    surname: "Nachname",
    tag: "Kennzeichen",
    birthday: "Geburtstag",
    country: "Land",
    address: "Adresse",
    postCode: "Postleitzahl",
    bank: "Bank",
    expirationDate: "Ablaufdatum",
    cardHolder: "Karteninhaber",
    cardNumber: "Kartennummer",
    partlyCloudy: "Teilweise bewölkt",
    humidity: "Luftfeuchtigkeit",
    dew: "Tau",
    pressure: "Druck",
    windSpeed: "Windgeschwindigkeit",
    footer: `Copyright © ${currentYear} Progress Software. Alle Rechte vorbehalten.`,
    home: "Startseite",
    january: "Januar",
    february: "Februar",
    march: "März",
    april: "April",
    may: "Mai",
    june: "Juni",
    july: "Juli",
    august: "August",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Dezember",
    relatedTopics: "Verwandte Themen",
    chatWithRoby: "Mit Roby chatten",
};

export const deComponentMessages = {
    // Grid
    "kendo.grid.groupPanelEmpty":
        "Ziehen Sie eine Spaltenüberschrift hierher, um nach dieser Spalte zu gruppieren",
    "kendo.grid.noRecords": "Keine Einträge verfügbar.",
    "kendo.grid.pagerFirstPage": "Zur ersten Seite",
    "kendo.grid.pagerPreviousPage": "Zur vorherigen Seite",
    "kendo.grid.pagerNextPage": "Zur nächsten Seite",
    "kendo.grid.pagerLastPage": "Zur letzten Seite",
    "kendo.grid.pagerPage": "Seite",
    "kendo.grid.pagerOf": "von",
    "kendo.grid.pagerItems": "Einträge",
    "kendo.grid.pagerItemsPerPage": "Einträge pro Seite",
    "kendo.grid.pagerPageNumberInputTitle": "Seitenzahl",
    "kendo.grid.filter": "Filter",
    "kendo.grid.filterEqOperator": "Ist gleich",
    "kendo.grid.filterNotEqOperator": "Ist nicht gleich",
    "kendo.grid.filterIsNullOperator": "Ist null",
    "kendo.grid.filterIsNotNullOperator": "Ist nicht null",
    "kendo.grid.filterIsEmptyOperator": "Ist leer",
    "kendo.grid.filterIsNotEmptyOperator": "Ist nicht leer",
    "kendo.grid.filterStartsWithOperator": "Beginnt mit",
    "kendo.grid.filterContainsOperator": "Enthält",
    "kendo.grid.filterNotContainsOperator": "Enthält nicht",
    "kendo.grid.filterEndsWithOperator": "Endet mit",
    "kendo.grid.filterGteOperator": "Ist größer als oder gleich",
    "kendo.grid.filterGtOperator": "Ist größer als",
    "kendo.grid.filterLteOperator": "Ist kleiner als oder gleich",
    "kendo.grid.filterLtOperator": "Ist kleiner als",
    "kendo.grid.filterIsTrue": "ist wahr",
    "kendo.grid.filterIsFalse": "ist falsch",
    "kendo.grid.filterBooleanAll": "(Alle)",
    "kendo.grid.filterAfterOrEqualOperator": "Ist nach oder gleich",
    "kendo.grid.filterAfterOperator": "Ist nach",
    "kendo.grid.filterBeforeOperator": "Ist vor",
    "kendo.grid.filterBeforeOrEqualOperator": "Ist vor oder gleich",
    "kendo.grid.filterFilterButton": "Filtern",
    "kendo.grid.filterClearButton": "Löschen",
    "kendo.grid.filterAndLogic": "Und",
    "kendo.grid.filterOrLogic": "Oder",
    "kendo.grid.filterDateToggle": "Kalender umschalten",
    "kendo.grid.filterDateToday": "Heute",
    "kendo.grid.filterNumericDecrement": "Wert verringern",
    "kendo.grid.filterNumericIncrement": "Wert erhöhen",
    "kendo.grid.loading": "Wird geladen",
    "kendo.grid.sort": "Sortieren",
    "kendo.grid.columnMenu": "Spaltenmenü",
    "kendo.grid.columns": "Spalten",
    "kendo.grid.lock": "Sperren",
    "kendo.grid.unlock": "Entsperren",
    "kendo.grid.stick": "Anheften",
    "kendo.grid.unstick": "Lösen",
    "kendo.grid.setColumnPosition": "Spaltenposition festlegen",
    "kendo.grid.sortAscending": "Aufsteigend sortieren",
    "kendo.grid.sortDescending": "Absteigend sortieren",
    "kendo.grid.columnsApply": "Anwenden",
    "kendo.grid.columnsReset": "Zurücksetzen",
    "kendo.grid.sortable": "Sortierbar",
    "kendo.grid.sortedAscending": "Aufsteigend sortiert",
    "kendo.grid.sortedDescending": "Absteigend sortiert",
    "kendo.grid.sortedDefault": "Nicht sortiert",

    // DropDowns
    "kendo.autocomplete.noDataText": "Keine Daten gefunden",
    "kendo.autocomplete.clearTitle": "Löschen",
    "kendo.combobox.noDataText": "Keine Daten gefunden",
    "kendo.combobox.clearTitle": "Löschen",
    "kendo.dropdownlist.noDataText": "Keine Daten gefunden",
    "kendo.dropdownlist.clearTitle": "Löschen",

    // Calendar
    "kendo.calendar.today": "HEUTE",

    // TextBox
    "kendo.textbox.clearTitle": "Löschen",

    // DatePicker
    "kendo.datepicker.today": "HEUTE",
    "kendo.datepicker.toggle": "Kalender umschalten",

    // DateInput
    "kendo.dateinput.increment": "Wert erhöhen",
    "kendo.dateinput.decrement": "Wert verringern",

    // NumericTextBox
    "kendo.numerictextbox.increment": "Wert erhöhen",
    "kendo.numerictextbox.decrement": "Wert verringern",

    // AIPrompt
    "kendo.aiprompt.generateOutput": "Generieren",
    "kendo.aiprompt.copyOutput": "Kopieren",
    "kendo.aiprompt.retryGeneration": "Wiederholen",
    "kendo.aiprompt.outputView": "Ausgabe",
    "kendo.aiprompt.promptView": "KI FRAGEN",
    "kendo.aiprompt.promptPlaceholder": "Wie kann ich...",
    "kendo.aiprompt.promptSuggestions": "Eingabevorschläge",
};